import { useEffect, useState } from 'react';

/* 모바일(휴대폰) 판정 — 767px 이하 (2026-11-05 모바일 대응).
   데스크톱 화면은 바꾸지 않는다: 모바일 전용 배치는 전부 이 값으로 갈라 둔다.
   lab · partner 에 같은 사본이 있다 — 한쪽만 고치지 말 것 */
export const MOBILE_QUERY = '(max-width: 767px)';
export const isMobileNow = () => typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(MOBILE_QUERY).matches;

export function useIsMobile() {
  const [m, setM] = useState(isMobileNow);
  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    const on = () => setM(mq.matches);
    mq.addEventListener ? mq.addEventListener('change', on) : mq.addListener(on);
    return () => { mq.removeEventListener ? mq.removeEventListener('change', on) : mq.removeListener(on); };
  }, []);
  return m;
}
